<div class="col-lg-12 content-scroll-screen parent">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span
        class="d-flex justify-content-between align-items-center p-3 globalborder-btm-header">
        <span class="col-auto">
          <h2 class="mb-0">Product List</h2>
        </span>
        <span class="cross-border" (click)="onCloseModal()"
          ><i class="pi pi-times"></i
        ></span>
      </span>
      <div class="col-lg-12 adduser-container-hgt">
        <p-table
          #dt
          stripedRows
          [rows]="50"
          [showCurrentPageReport]="true"
          [scrollable]="true"
          scrollHeight="calc(100vh - 310px)"
          [size]="'small'"
          responsiveLayout="scroll"
          [value]="filterVariantsListing"
          styleClass="p-datatable-customers ordersListing search-more"
          [rowHover]="true"
          [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10, 20, 50, 250, 1000]"
          [paginator]="true"
          [filterDelay]="0"
          sortMode="multiple"
          styleClass="table-listing">
          >
          <ng-template pTemplate="header">
            <tr class="table-head">
              <th
                pSortableColumn="ecoResDistinctProductVariantDisplayProductNumberD365">
                Product number
                <p-sortIcon
                  field="ecoResDistinctProductVariantDisplayProductNumberD365"></p-sortIcon>
              </th>
              <th class="status" pSortableColumn="nameD365">
                Product name
                <p-sortIcon field="nameD365"></p-sortIcon>
              </th>
              <th class="status" pSortableColumn="sizeD365">
                Size
                <p-sortIcon field="sizeD365"></p-sortIcon>
              </th>
              <th class="name" pSortableColumn="colorD365">
                Color
                <p-sortIcon field="colorD365"></p-sortIcon>
              </th>
            </tr>
            <tr>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="ecoResDistinctProductVariantDisplayProductNumberD365
"
                    id="ecoResDistinctProductVariantDisplayProductNumberD365
"
                    style="max-width: 200px"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'ecoResDistinctProductVariantDisplayProductNumberD365',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="nameD365"
                    id="nameD365"
                    style="max-width: 200px"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'nameD365',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="sizeD365"
                    id="sizeD365"
                    style="max-width: 200px"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'sizeD365',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="colorD365"
                    id="colorD365"
                    style="max-width: 200px"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'colorD365',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
            </tr>
          </ng-template>
          <ng-template
            pTemplate="body"
            let-productsListing
            let-rowIndex="rowIndex">
            <tr>
              <td>
                {{
                  productsListing.ecoResDistinctProductVariantDisplayProductNumberD365
                }}
              </td>
              <td>
                {{ productsListing.nameD365 }}
              </td>
              <td>
                {{ productsListing.sizeD365 }}
              </td>
              <td>
                {{ productsListing.colorD365 }}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="20">No Variants found.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </p-card>
  </div>
</div>
